module.exports = __webpack_public_path__ + "static/media/mercury-cafe-seo.ef898ffb.png";